<template class="trackandtrace">
    <div v-if="checkAuthorization.trackandtrace || checkOsol">
        <SearchBar v-if="!isOsol" :clientId="this.$store.state.clients.current" />

        <div v-if="$store.state.loader.loading">
            <v-skeleton-loader :loading="$store.state.loader.loading" type="table"></v-skeleton-loader>
        </div>

        <v-row v-else-if="this.$store.state.scopeflows.results && this.$store.state.scopeflows.results.length !== 1">
            <v-col md="8">
                <v-card class="elevation-0">
                    <v-card-title
                        >{{ $t('trackandtrace.results_title') }} : {{ this.$store.state.scopeflows.results.length }}
                        <v-text-field
                            v-model="search"
                            :label="$t('forms.search')"
                            single-line
                            hide-details
                            color="#3200E6"
                            class="search"
                            append-icon="mdi-magnify"
                        />
                    </v-card-title>

                    <br />
                    <div class="content">
                        <ResultTable
                            skin="elevation-0"
                            :config-headers-id="getHeaderConfigId()"
                            :default-config-id="'T&T_default'"
                            :search="search"
                            :items="this.$store.state.scopeflows.results"
                            :singleClickAction="showMapAndSummary"
                            :doubleClickAction="() => goto('Details')"
                            :init-selected-row="selectedRow"
                            :initialPage="page"
                            :saveChanges="true"
                            @pageChanged="
                                data => {
                                    page = data;
                                }
                            "
                        />
                    </div>
                </v-card>
            </v-col>
            <v-col v-if="Object.keys(selectedRow).length > 0" md="4">
                <v-flex>
                    <v-card>
                        <v-card-title>{{ $t('trackandtrace.mapAndRoutes') }}</v-card-title>
                        <Map
                            class="map"
                            :departure="selectedRow.origin"
                            :arrival="selectedRow.destination"
                            :coordinates="selectedRow.coordinates"
                        />
                        <v-card-text>
                            <v-row class="summary">
                                <v-col md="7">
                                    <v-row class="title">{{ $t('trackandtrace.preview.origin') }}:</v-row>
                                    <v-row>
                                        <b>{{ selectedRow.loadingCorporateName }}</b>
                                    </v-row>
                                    <v-row>{{ selectedRow.loadingAddress }}</v-row>
                                    <v-row>
                                        {{ selectedRow.loadingTown }}
                                        {{ selectedRow.loadingArea }}
                                    </v-row>
                                    <v-row class="last-text">{{ selectedRow.loadingCountry }}</v-row>
                                    <v-row class="title">{{ $t('trackandtrace.preview.destination') }} :</v-row>
                                    <v-row>
                                        <b>{{ selectedRow.unloadingCorporateName }}</b>
                                    </v-row>
                                    <v-row>{{ selectedRow.unloadingAddress }}</v-row>
                                    <v-row>
                                        {{ selectedRow.unloadingTown }}
                                        {{ selectedRow.unloadingArea }}
                                    </v-row>
                                    <v-row class="last-text">
                                        {{ selectedRow.unloadingCountry }}
                                    </v-row>
                                    <v-row class="title">{{ $t('trackandtrace.preview.lastEvent') }} :</v-row>
                                    <v-row>
                                        <b>{{ selectedRow.eventDescription ? selectedRow.eventDescription.referenceValue : '' }}</b>
                                    </v-row>
                                    <v-row>{{ selectedRow.eventDate }}</v-row>
                                    <v-row>
                                        {{ selectedRow.eventTime }}
                                        {{ selectedRow.eventTimeZone }}
                                    </v-row>
                                    <v-row class="last-text">{{ selectedRow.eventLocation }}</v-row>
                                </v-col>
                                <v-col md="5">
                                    <v-row justify="end">
                                        <v-btn class="action" small v-on:click="goto('Details')">
                                            {{ $t('trackandtrace.details.details') }} >
                                        </v-btn>
                                    </v-row>
                                    <v-row justify="end">
                                        <v-btn class="secondary-action" small v-on:click="goto('Events')">
                                            {{ $t('trackandtrace.events.events') }} >
                                        </v-btn>
                                    </v-row>
                                    <v-row justify="end">
                                        <v-btn class="secondary-action" small v-on:click="goto('Documents')">
                                            {{ $t('trackandtrace.documents.documents') }} >
                                        </v-btn>
                                    </v-row>
                                    <v-row justify="end">
                                        <v-btn class="secondary-action" small v-on:click="goto('Contents')">
                                            {{ $t('trackandtrace.content.content') }} >
                                        </v-btn>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-col>
        </v-row>
        <v-row v-else>
            <v-col align="center">
                <v-card class="text-center pa-6" max-width="400">
                    <v-icon>fas fa-arrow-up</v-icon>
                    <br />
                    <br />
                    {{ $t('trackandtrace.homeMessage') }}
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import { api } from '@/utils/api';
import SearchBar from '@/components/SearchBar';
import Map from '@/components/Map';
import ResultTable from '@/components/ResultTable';

export default {
    components: {
        Map,
        ResultTable,
        SearchBar
    },
    watch: {
        async page() {
            await this.$router.replace({ path: this.$router.path, query: { ...this.$route.query, page: this.page } });
        }
    },
    data() {
        return {
            shipments: [],
            search: '',
            headersFromConfig: null,
            temp: null,
            clicks: 0,
            timer: null,
            from: '',
            page: this.$route.query.page || 1
        };
    },
    computed: {
        ...mapGetters(['_getClient']),
        ...mapState({
            selectedRow: state => state.scopeflows.selectedRow,
            isOsol: state => state.scopeflows.isOsol
        }),
        checkAuthorization() {
            return {
                trackandtrace:
                    this.$store.state.groups.userRoles?.trackandtrace?.user || this.$store.state.groups.authorization?.admin
            };
        },
        checkOsol() {
            return {
                trackandtrace: this.$store.state.groups.userRoles?.trackandtrace?.anon
            };
        }
    },
    methods: {
        ...mapMutations(['setSelectedRow']),
        getHeaderConfigId() {
            if (this._getClient && this._getClient.id) {
                return this._getClient.id;
            }
            return 'T&T_default';
        },
        getPreviewData(previewData) {
            const {
                loadingCorporateName,
                loadingAddress,
                loadingTown,
                loadingArea,
                loadingCountry,
                unloadingCorporateName,
                unloadingAddress,
                unloadingTown,
                unloadingArea,
                unloadingCountry,
                eventDescription,
                eventDate,
                eventTime,
                eventTimeZone,
                eventLocation,
                coordinates
            } = previewData || {};
            return {
                loadingCorporateName,
                loadingAddress,
                loadingTown,
                loadingArea,
                loadingCountry,
                unloadingCorporateName,
                unloadingAddress,
                unloadingTown,
                unloadingArea,
                unloadingCountry,
                eventDescription,
                eventDate,
                eventTime,
                eventTimeZone,
                eventLocation,
                coordinates
            };
        },
        async showMapAndSummary(data) {
            this.temp = data;
            this.clicks++;
            if (this.clicks === 1) {
                this.timer = setTimeout(async () => {
                    const previewData = await api.get('preview', null, {
                        params: {
                            serviceNumber: data.customerServiceNumber,
                            customerHUReference: data.customerHUReference,
                            clientId: this.$store.state.clients.current,
                            scopeflow: this.$store.state.shipment.scopeflowsSearch
                        }
                    });
                    if (data.origin && data.destination) {
                        this.setSelectedRow({ ...data, ...this.getPreviewData(previewData) });
                    } else {
                        this.setSelectedRow({});
                    }
                    this.clicks = 0;
                }, 200);
            } else {
                clearTimeout(this.timer);
                this.clicks = 0;
            }
        },
        async goto(button) {
            if (!this.temp) return;
            const data = await api.get('preview', null, {
                params: {
                    serviceNumber: this.temp.customerServiceNumber,
                    customerHUReference: this.temp.customerHUReference,
                    clientId: this.$store.state.clients.current,
                    scopeflow: this.$store.state.shipment.scopeflowsSearch
                }
            });
            if (!data) return;
            this.$router.push({
                path: `/${this.$store.getters.getClientName}/trackandtrace/shipment`,
                query: {
                    id: data.serviceNumber,
                    churef: this.temp.customerHUReference,
                    tab: button
                }
            });
        }
    },
    mounted() {
        // clean results if going to T&T page for first time
        if (this.from.name === 'Client') {
            this.$store.commit('resetResults', {});
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.from = from;
        });
    }
};
</script>

<style lang="scss" scoped>
@import '@/scss/_colors.scss';

.content {
    margin: 0 16px;
}
.search {
    margin-left: 32px;
    max-width: 316px;
    font-weight: 400;
    padding-top: 0px;
}
.map {
    height: 300px;
}
.summary {
    padding-left: 16px;
    padding-right: 16px;
    .last-text {
        margin-bottom: 16px;
    }
    .action,
    .secondary-action {
        margin-bottom: 16px;
    }
    .title {
        color: $primary;
        font-weight: 400;
        font-size: 18px;
    }

    b {
        color: #818180;
        font-weight: 600;
        font-size: 16px;
    }
}
</style>
